/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTagesplanDto } from '../../models/create-tagesplan-dto';
import { TagesplanDto } from '../../models/tagesplan-dto';

export interface CreateTagesplan$Json$Params {
  
    /**
     * Daten für den neuen Tagesplan
     */
    body?: CreateTagesplanDto
}

export function createTagesplan$Json(http: HttpClient, rootUrl: string, params?: CreateTagesplan$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TagesplanDto>> {
  const rb = new RequestBuilder(rootUrl, createTagesplan$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagesplanDto>;
    })
  );
}

createTagesplan$Json.PATH = '/v1/tagesplaene';
